
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import { Loading, Tooltip, Modal, ModalBody, ModalFooter, Button, ToggleSwitch, Tabs, TabContainer } from "@gpstrackit/react-controls";
import RefreshIcon from '@mui/icons-material/Refresh';
import { Grid, IconButton } from "@mui/material";
import Summary from 'Components/Summary';
import Preferences from 'Core/containers/Preferences';
import { Chip } from "@mui/material";
import { getDateFormatted, getQuery } from 'Core/data/Helpers';
import DataView from 'Components/DataView';
//Notification
import {
    NotificationManager
} from "Components/Notifications";
//Endpoints
import {
    endpoints
} from 'Core/defaultValues';

//Actions
import {
    pulsInfoRequest,
    pulsFilesRequest,
    showPulsInfoModalHide,
    clearRedux
} from 'Redux/actions';

const PulsInfo = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { device, height } = props;

    const preferencesRef = useRef();

    const { loading, result, loadingFiles, files, openModal } = useSelector(state => state.pulsInfoRedux);
    const [details, setDetails] = useState(null);
    const [tabMode, setTabMode] = useState(props.tabMode);
    const [jsonView, setJsonView] = useState(false);
    const [tab, setTab] = useState(0);
    const [currentLogs, setCurrentLogs] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    const [columns, setColumns] = useState([
        {
            key: "fileType",
            title: messages['calamp_files_file_type'],
            show: true,
            resize: true,
            width: 200,
            sort: true,
            export: true,
            exportCell: 'newDeviceFile.platforms[0].value',
            code: "calamp_files_file_type",
            render: (item) => {
                return <span>
                    {
                        item?.newDeviceFile?.platforms[0]?.value
                    }
                </span>
            }
        },
        {
            key: "lastUpdate",
            title: messages['calamp_files_last_update'],
            show: true,
            resize: true,
            width: 100,
            sort: true,
            export: true,
            exportCell: 'lastUpdateTime',
            exportFormat: "datetime",
            code: "calamp_files_last_update",
            render: (item) => {
                return <span>{item?.lastUpdateTime && getDateFormatted(item?.lastUpdateTime, "date", "datetime")}</span>
            }
        },
        {
            key: "newVersion",
            title: messages['calamp_files_new_version'],
            show: true,
            resize: true,
            width: 200,
            export: true,
            exportCell: 'newVersion',
            code: "calamp_files_new_version",
            render: (item) => {
                return <span>{item?.newVersion}</span>
            }
        },
        {
            key: "status",
            title: messages['calamp_files_status'],
            show: true,
            resize: true,
            width: 200,
            export: true,
            exportCell: 'transactionStatus.name',
            code: "calamp_files_status",
            render: (item) => {
                return <span>{item?.transactionStatus?.name}</span>
            }
        }
    ]);

    const getData = () => {
        let payload = {
            esn: device?.esn,
            calampApi: device?.unitConfig?.calampApi || "PULS"
        }
        dispatch(pulsInfoRequest(payload))
    }

    const getFilesData = (current) => {

        let logs = typeof current === "undefined" ? currentLogs : current

        let payload = {
            esn: device?.esn,
            current: logs
        }
        dispatch(pulsFilesRequest(payload))
    }

    useEffect(() => {
        if (result) {
            if (result.error) {
                if (result.error === true) {
                    setDetails({ error: true })
                } else {
                    let errorLabel = result.error.error === "PulsCustomerId was not found" ? messages["calamp_puls_customer_missing"] : result.error.error
                    NotificationManager.error(
                        errorLabel,
                        messages['calamp_info_title'],
                        6000
                    );
                    setErrorMessage(errorLabel)
                    setDetails({ error: true })
                }
            } else {
                let currentDetails = JSON.parse(result);
                setDetails(currentDetails);
            }
        }
    }, [result])

    useEffect(() => {
        getData();
        getFilesData();
        return () => {
            setDetails(null);
            setErrorMessage("");
            dispatch(clearRedux("PULS_INFO_TAB"));
        }
    }, [])

    const closeModal = () => {
        dispatch(showPulsInfoModalHide());
    }

    const changePreferences = (newValues) => {
        setJsonView(newValues)
        const oldPreferences = preferencesRef?.current?.getPreferences("Other", "calampInfo") || {}
        if (!_.isEqual(newValues, oldPreferences)) {
            const currentPreferences = { ...oldPreferences, calampInfo: newValues }
            preferencesRef.current.savePreference("Other", "calampInfo", currentPreferences)
        }
    }

    let indexCount = 0;

    const renderPulsInfo = () => {
        return (
            <Preferences
                ref={preferencesRef}
                preferencesKey="calampInfo"
                onInitialPreferences={(preferences) => {
                    if (preferences?.calampInfo != undefined && preferences.calampInfo != null) {
                        setJsonView(preferences?.calampInfo)
                    }
                }}
            >
                <div className="sim-info-container" style={{ height: height, overflow: 'auto' }}>
                    {loading && <Loading overlay show />}
                    {
                        details?.error
                            ?
                            <div className="error-container"><p>{result.error === true ? messages['common_no_information_to_display'] : errorMessage}</p></div>
                            :
                            <>
                                <Tabs tab={+tab} onChange={(numberTab) => { setTab(numberTab) }}>
                                    <TabContainer
                                        label={messages['calamp_info']}
                                        index={indexCount++}
                                        style={{ marginTop: tabMode ? 10 : 80 }}
                                    >
                                        <div className="calamp-info-header">
                                            <Tooltip title={messages['refresh']}>
                                                <IconButton onClick={() => getData()} size="large">
                                                    <RefreshIcon style={{ color: 'black', fontSize: 20 }} />
                                                </IconButton>
                                            </Tooltip>
                                            <a
                                                href={device?.unitConfig?.calampApi === "CTC" ? `${endpoints?.CALAMP_URL}/doctc/#/deviceDetail?${details?.id}&${details?.esn}` : `${endpoints?.PULS_URL}?esn=${device?.esn}`}
                                                style={{ color: '#1D2734', textDecoration: 'underline', cursor: 'pointer', margin: '0 10px' }}
                                                target="_blank"
                                            >
                                                {messages['calamp_info_url']}
                                            </a>
                                            <Chip style={!jsonView ? {
                                                backgroundColor: '#66bb6a',
                                                color: '#ffff',
                                                marginRight: 10
                                            } : { marginRight: 10 }} className={!jsonView ? "calamp-info-selected" : ""} label={messages['calamp_formatted']} onClick={() => changePreferences(false)} />
                                            <Chip style={jsonView ? {
                                                backgroundColor: '#66bb6a',
                                                color: '#ffff'
                                            } : {}} className={jsonView ? "calamp-info-selected" : ""} label={messages['calamp_unformatted']} onClick={() => changePreferences(true)} />
                                        </div>

                                        {details &&
                                            <div style={{ padding: '5px 14px' }}>
                                                {
                                                    jsonView ? (
                                                        <pre style={{ marginBottom: 25, fontSize: 'inherit' }}>
                                                            {JSON.stringify(details, undefined, 2)}
                                                        </pre>
                                                    ) : <Summary data={details} columns={4} addDash />
                                                }
                                            </div>}
                                    </TabContainer>
                                    {
                                        device?.unitConfig?.calampApi !== "PULS" &&
                                        <TabContainer
                                            label={messages['calamp_files']}
                                            index={indexCount++}
                                            style={{ marginTop: tabMode ? 40 : 80 }}
                                        >
                                            <DataView
                                                name="pm-calamp-files"
                                                exportName="calampfiles"
                                                columns={columns}
                                                externalData={files}
                                                externalLoading={loadingFiles}
                                                topheight={20}
                                                noSplit
                                                tableButtons={["export", 'orderColumn']}
                                                onChangeColumns={(items) => setColumns(items)}
                                                disableItemSelection
                                                dataGridExport
                                                noFilters
                                                noSearch
                                                externalRefresh={() => getFilesData()}
                                                infiniteScroll
                                                hasMore={false}
                                                noPDF
                                                extraButton={() => {
                                                    return (
                                                        <ToggleSwitch
                                                            id="accounts-internal"
                                                            medium
                                                            blueToggle
                                                            optionLabels={[messages['calamp_files_current'], messages['calamp_files_log']]}
                                                            checked={currentLogs}
                                                            onChange={(checked) => {
                                                                setCurrentLogs(checked)
                                                                getFilesData(checked)
                                                            }}
                                                        />
                                                    )
                                                }}
                                            />
                                        </TabContainer>
                                    }
                                </Tabs>

                            </>
                    }
                </div>
            </Preferences>
        );
    }

    return (
        <Grid>
            {
                tabMode &&
                renderPulsInfo()
            }
            {
                !tabMode &&
                <Modal
                    open={openModal}
                    title={messages['calamp_info_title']}
                    position="right"
                    size="medium"
                    handleClose={closeModal}
                    loading={loading}
                >
                    <ModalBody>
                        {renderPulsInfo()}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn btn-dark-blue"
                            onClick={() => closeModal()}
                        >
                            {messages['common_close']}
                        </Button>
                    </ModalFooter>
                </Modal>
            }
        </Grid>
    )
}

export default PulsInfo;